import {
  useState,
  useEffect,
  useContext,
  useRef,
  useMemo,
  useCallback,
} from "react";
import Select from "react-select";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import customStyles from "app/shared-components/SelectCustomStyle";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { DocumentUploadContext } from "./Document";
import AgGridTable from "../utilities/AgGridTable";
import UploadDocument from "./celleditor-component/UploadDocument";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import OAuthService from "src/app/auth/services/oAuthService";
import DialogBox from "../utilities/DialogBox";

const intialValue = [
  {
    folderName: "BL",
    attachmentName: "",
    comments: "",
    file: "",
  },
  {
    folderName: "INVOICE",
    attachmentName: "",
    comments: "",
    file: "",
  },
  {
    folderName: "PACKAGING_LIST",
    attachmentName: "",
    comments: "",
    file: "",
  },
  {
    folderName: "DETAILS_PACKING_LIST",
    attachmentName: "",
    comments: "",
    file: "",
  },
  {
    folderName: "CERTIFICATE_OF_ORIGIN",
    attachmentName: "",
    comments: "",
    file: "",
  }
];

const DocumentUpload = () => {
  const containerAttachmentUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.getContainerAttachment}`;
  const uploadAttachementUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.containerUploadAttachement}`;
  const deletettachementUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.deleteDocument}`;
  const containerPlanUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.containerPlans}`;

  const [
    docUploadDialog,
    setDocUploadDialog,
    containerOptions,
    containerNo,
    handleContainerNoChange,
    openUploadDocDialog,
  ] = useContext(DocumentUploadContext);

  const gridRef = useRef();
  const [rowData, setRowData] = useState(intialValue);
  const [gridApi, setGridApi] = useState(null);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [containerComment, setContainerComment] = useState("");
  const [updateData, setUpdateData] = useState([]);
  const [rowEvent, setRowEvent] = useState("");
  const [columnDefs, setColumnDefs] = useState([
    {
      field: "folderName",
      enableRowGroup: true,
      rowGroup: true,
      hide: true,
      editable: false,
      cellEditor: UploadDocument,
      cellRenderer: (props) => { 
        return props?.value?.toLowerCase().split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
      },
    },
    {
      field: "attachmentName",
      cellEditor: UploadDocument,
      enableRowGroup: true,
      checkboxSelection: true,
      // hide: true,
    },
    {
      field: "comments",
      enableRowGroup: true,
    },
    { field: "file", hide: true, editable: false },
    // {
    //   field: "upload",
    //   enableRowGroup: true,

    // },
  ]);

  const openDeleteDialog = () => {
    setShowDeleteDialog(true);
  };

  const handleClose = () => {
    setShowDeleteDialog(false);
  };

  const getAttachment = async () => {
    const attachments = await OAuthService.getEditData(
      containerAttachmentUrl,
      containerNo
    );

    const result = [];
    // Merge the arrays
    const mergedArray = [...attachments.data];
    // Add the missing folders with empty files
    rowData.forEach((folderItem) => {
      const existingFolder = mergedArray.find(
        (item) => item.folderName === folderItem.folderName
      );
      if (!existingFolder) {
        result.push({
          folderName: folderItem.folderName,
          attachmentName: folderItem.attachmentName,
          comments: folderItem.comments,
        });
      }
    });
    // Add the missing IDs to the merged items
    let nextID = attachments.data.length + 1;
    mergedArray.forEach((item) => {
      if (!item.id) {
        item.id = nextID++;
      }
    });
    // Add merged items to the result
    result.push(...mergedArray);
    console.log(result);
    setRowData(result);
  };
  useEffect(() => {
    getAttachment();
  }, [containerNo]);

  const isRowSelectable = useMemo(() => {
    return (rowNode) => {
      return rowNode?.data?.attachmentName ? true : false;
    };
  }, []);

  const onGridReady = useCallback((params) => {
    setGridApi(params);
    var columnToolPanel = gridRef.current.api.getToolPanelInstance("columns");
    columnToolPanel.expandColumnGroups();
  }, []);
  const getRowStyle = (params) => {
   if(params.node.group){
     if(params?.node?.allLeafChildren[0]?.data?.attachmentName === ''){
       return {background:'#9A3B3B'}
     }
     

   }
  };

  const onBtAdd = useCallback((event) => {
    const data = event.node.data;
    const newRow = { folderName: data.folderName };

    const newRowDate = gridRef.current.api.applyTransaction({
      add: [newRow],
    });
    const RowIndex = newRowDate.add[0].rowIndex;
    // updateData.splice(RowIndex, 0, newRow);
    gridRef.current.api.refreshCells();

    setTimeout(() => {
      gridRef.current.api.setFocusedCell(RowIndex, "attachmentName");
      gridRef.current.api.startEditingCell({
        rowIndex: RowIndex,
        colKey: "attachmentName",
      });
    }, 800);
  }, []);
  const onBtStartEditing = useCallback((event) => {
    const index = event.node.rowIndex;
    gridRef.current.api.setFocusedCell(index, "attachmentName");
    gridRef.current.api.startEditingCell({
      rowIndex: index,
      colKey: "attachmentName",
    });
  }, []);
  const onBtDeleteRow = useCallback(
    (event) => {
      const selectedRow = gridApi.api.getSelectedRows();
      // rowData.splice(event.node.rowIndex, 1);
      gridRef?.current?.api.applyTransaction({ remove: selectedRow });
      selectedRow.map(async (row) => {
        const model = {
          containerPlanId: containerNo,
          folderName: row.folderName,
          fileName: row.attachmentName,
        };
        await OAuthService.deleteData(deletettachementUrl, "", model);
        handleClose();
      });
    },
    [gridApi, rowData]
  );

  const onRowValueChanged = useCallback(
    async (event) => {
      let data = event.data;
      const model = {
        containerNo: containerNo,
        folderName: data.folderName,
        attachmentName: data.attachmentName,
        file: data.file,
        rowIndex: event.node.rowIndex,
      };
      if (
        updateData.filter((doc) => doc.rowIndex === event.node.rowIndex)
          .length > 0
      ) {
        const updatedData = updateData.map((item) => {
          if (item.rowIndex === event.node.rowIndex) {
            item.file = data.file;
          }
          return item;
        });
        setUpdateData(updatedData);
      } else {
        setUpdateData([...updateData, model]);
      }
    },
    [updateData, containerNo]
  );

  const getContextMenuItems = (event) => {
    setRowEvent(event);
    var result = [
      {
        name: "Add Row",
        icon: '<span><i class="material-icons style="font-size: 18px">perm_identity</i></span>',
        action: () => {
          onBtAdd(event);
        },
      },
      {
        name: "Edit Row",
        icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
        action: () => {
          onBtStartEditing(event);
        },
      },
      {
        name: "Delete Row",
        icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
        action: () => {
          // onBtDeleteRow(event);
          openDeleteDialog();
        },
      },
    ];
    return result;
  };
console.log('updateData', updateData)
  const handleSubmit = async () => {
    // setCheckSubmit(true);
    try {
      updateData.map(async (data) => {
        if (data.file) {
          const formData = new FormData();
          const folderName = data.folderName.toUpperCase().replace(" ", "_");
          console.log('folderName', folderName)
          formData.append("containerNo", data.containerNo);
          formData.append("folderName", folderName);
          formData.append("file", data.file);
          const res = await OAuthService.uploadFile(
            uploadAttachementUrl,
            formData
          );
          if (res.status === 200){
            getAttachment();
            setUpdateData([]);
          }
          setSuccessMsg("Data saved Successfully");
          setSnackState(true);
          setTimeout(() => {
            setSnackState(false);
          }, 2000);
        } else {
          setSuccessMsg("Please fill all fields");
          setSnackState(true);
          setTimeout(() => {
            setSnackState(false);
          }, 2000);
        }
      });
    } catch (error) {
      setError(error.message);
      return;
    }
  };
  // useEffect(() => {
  //   if (openUploadDocDialog) {
  //     setDocUploadDialog(openUploadDocDialog);
  //   }
  // }, [openUploadDocDialog]);
  return (
    <>
      <Dialog
        open={docUploadDialog}
        onClose={() => setDocUploadDialog(false)}
        fullWidth={true}
        maxWidth={"md"}
      >
        <DialogTitle>
          <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0">
            <span>Documents Upload</span>
            <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
              <Button onClick={() => setDocUploadDialog(false)}>
                <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
              </Button>
            </div>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
            <Grid container spacing={2} className="mb-16">
              <Grid item xs={3}>
                <Stack>
                  <label>Select Container No</label>
                  <Select
                    name="containerNo"
                    value={
                      containerNo &&
                      containerOptions &&
                      containerOptions.filter(
                        (obj) => containerNo === obj.value
                      )
                    }
                    onChange={handleContainerNoChange}
                    options={containerOptions}
                    styles={customStyles()}
                  />
                </Stack>
              </Grid>
              <Grid item xs={5}>
                <Stack>
                  <label>Container Comment</label>
                  <TextField
                    className="mb-16"
                    type="text"
                    name="containerComment"
                    value={containerComment}
                    onChange={(e) => {
                      setContainerComment(e.target.value);
                    }}
                    variant="outlined"
                  />
                </Stack>
              </Grid>
              <Grid item xs={4} className="flex justify-end mt-24">
                <Button
                  variant="contained"
                  color="warning"
                  onClick={() => handleSubmit()}
                >
                  <Typography color="black">Save Document</Typography>
                </Button>
              </Grid>
            </Grid>
            <div className="h-[400px]">
              <AgGridTable
                rowData={rowData}
                gridRef={gridRef}
                columnDefs={columnDefs}
                editable={true}
                editType={"fullRow"}
                // autoGroupField={"attachmentName"}
                groupCheckBox={true}
                hideCheckbox={true}
                suppressRowCount={true}
                isRowSelectable={isRowSelectable}
                getContextMenuItems={getContextMenuItems}
                onGridReady={onGridReady}
                groupRowMinWidth={150}
                onRowValueChanged={onRowValueChanged}
                getRowStyle={getRowStyle}
                // tableClassName={'highlightGroupRow'}
                // onSelectionChanged={onSelectionChanged}
              />
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <DialogBox
        open={showDeleteDialog}
        handleClose={handleClose}
        handleSumbit={() => onBtDeleteRow(rowEvent)}
        title={"remove document"}
      />
    </>
  );
};

export default DocumentUpload;
